import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertBmpToPng() {
  return <ImageConverterTemplate sourceFormat="BMP" targetFormat="PNG" acceptTypes=".bmp,image/bmp" slug="convert-bmp-to-png" gradientColors="from-blue-500 to-cyan-600" accentColor="blue" />;
}
